import { Component, Input } from '@angular/core';

export interface Step {
  title: string;
  subtitle: string;
  label: string;
}

@Component({
  selector: 'fcp-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss']
})
export class StepsComponent {

  @Input() public steps: Array<Step>;
  @Input() public selectedIndex: number;

  constructor() { }

  public getPercent(): number {
    const stepSelected = this.steps.filter((step, index) => index <= this.selectedIndex);
    return stepSelected.length * 100 / this.steps.length;
  }


}
